import { useNavigate } from "react-router-dom";

const NotAllowed = () => {
  const navigate = useNavigate();

  const goBack = () => navigate(-1);

  return (
    <div className="d-flex justify-content-center mt-5 text-center">
      <section>
        <h1>Not Allowed</h1>
        <br />
        <p className="fs-5">
          You are logged in so you do not have access to this page..
        </p>
        <div>
          <button className="btn btn-secondary" onClick={goBack}>
            Go Back
          </button>
        </div>
      </section>
    </div>
  );
};

export default NotAllowed;
